const isProd = process.env.APP_ENV === 'prod' || process.env.APP_ENV === 'uat';

export const H2_FINANCE_SUBGRAPH = isProd
  ? 'https://api.goldsky.com/api/public/project_clwrfupe2elf301wlhnd7bvva/subgraphs/h2-exchange-v2-cronos-zkevm/latest/gn'
  : 'https://api.goldsky.com/api/public/project_clwrfupe2elf301wlhnd7bvva/subgraphs/h2-exchange-v2-cronos-zkevm-testnet/latest/gn';
